import React, { createContext, useContext, useState } from 'react';
import fr from './fr';
import en from './en';

const translations = { fr, en };

const I18nContext = createContext(null);

/**
 * Provider i18n — Enrober l'application entière
 */
export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    return localStorage.getItem('savinvest_lang') || 'fr';
  });

  const t = translations[locale] || translations.fr;

  const toggleLocale = () => {
    const next = locale === 'fr' ? 'en' : 'fr';
    setLocale(next);
    localStorage.setItem('savinvest_lang', next);
  };

  const setLang = (lang) => {
    if (translations[lang]) {
      setLocale(lang);
      localStorage.setItem('savinvest_lang', lang);
    }
  };

  return (
    <I18nContext.Provider value={{ t, locale, toggleLocale, setLang }}>
      {children}
    </I18nContext.Provider>
  );
}

/**
 * Hook useTranslation — Accéder aux traductions dans n'importe quel composant
 * @example
 * const { t, locale, toggleLocale } = useTranslation();
 * return <h1>{t.dashboard.title}</h1>
 */
export function useTranslation() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useTranslation doit être utilisé dans un I18nProvider');
  return ctx;
}

export default I18nContext;
